import {
  ADD_NEGOTIATION_ACTION,
  ADD_NEGOTIATION_ACTION_FAILURE,
  ADD_NEGOTIATION_ACTION_SUCCESS,
  DELETE_NEGOTIATION_ACTION,
  DELETE_NEGOTIATION_ACTION_FAILURE,
  DELETE_NEGOTIATION_ACTION_SUCCESS,
  GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE,
  GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS,
  GET_NEGOTIATION_ACTION_RELATION,
  GET_NEGOTIATION_ACTION_RELATION_FAILURE,
  GET_NEGOTIATION_ACTION_RELATION_SUCCESS,
  GET_NEGOTIATION_ACTIONS,
  GET_NEGOTIATION_ACTIONS_FAILURE,
  GET_NEGOTIATION_ACTIONS_SUCCESS,
} from "../Action/actionTypes";

interface NegotiationActionsState {
  negotiationActions: object[];
  negotiationActionRelation: object[];
  isLoaded: boolean;
  loading: boolean;
  error: string;
  aiApiError: string;
  negoAction: {
    name: string;
    description: string;
    actionType: string;
  };
  deleteAction: {
    id: any;
    status: boolean;
  };
  aiActionCardsData: any;
}

const initialState = {
  negotiationActions: [],
  negotiationActionRelation: [],
  loading: false,
  isLoaded: false,
  error: "",
  negoAction: {
    name: "",
    description: "",
    actionType: "",
  },
  deleteAction: {
    id: "",
    status: false,
  },
  aiActionCardsData: {},
  aiApiError: "",
};
const NegotiationActionsReducer = (
  state = initialState,
  action: any
): NegotiationActionsState => {
  switch (action.type) {
    case GET_NEGOTIATION_ACTIONS:
    case GET_NEGOTIATION_ACTION_RELATION:
    case ADD_NEGOTIATION_ACTION:
    case DELETE_NEGOTIATION_ACTION:
      return {
        ...state,
        loading: true,
        isLoaded: true,
      };
    case GET_NEGOTIATION_ACTIONS_SUCCESS:
      {
        let negotiationActionsArr = action.payload.map((data: any) => {
          return {
            id: data.id,
            title: data.title,
            description: data.description,
            flag: data.flag,
            relatedPhase: data.relatedPhase,
            status: data.status,
            preselected: data.preselected,
            actionType: data.actionType,
            isTrending: data.isTrending,
            isMostSelected: data.isMostSelected,
            avgRating:data.avgRating
          };
        });
        return {
          ...state,
          negotiationActions: negotiationActionsArr,
          loading: false,
          isLoaded: false,
        };
      }
    case GET_NEGOTIATION_ACTIONS_FAILURE:
    case GET_NEGOTIATION_ACTION_RELATION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isLoaded: false,
      };

    case GET_NEGOTIATION_ACTION_RELATION_SUCCESS:
      return {
        ...state,
        negotiationActionRelation: action.payload,
        loading: false,
        isLoaded: false,
      };

    case ADD_NEGOTIATION_ACTION_SUCCESS:
      return {
        ...state,
        negoAction: action.payload,
        loading: false,
      };
    case ADD_NEGOTIATION_ACTION_FAILURE:
    case DELETE_NEGOTIATION_ACTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case DELETE_NEGOTIATION_ACTION_SUCCESS:
      return {
        ...state,
        deleteAction: action.payload,
        loading: false,
      };

    case GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS:
      return {
        ...state,
        aiActionCardsData: action.payload,
      };
    case GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE:
      return {
        ...state,
        aiApiError: action.payload,
      };
    default:
      return state;
  }
};
export default NegotiationActionsReducer;
